import React from 'react';
import classNames from 'classnames';
import Color from 'color';
import './LeadPopupPreview.pcss';
import previewMockImg from './preview-mock.png';
import { PreviewIphone } from '../../common/PreviewIphone/PreviewIphone';

const getComplementaryColor = (color: string) =>
  Color(color).luminosity() < 0.75 ? 'white' : 'black';

type Props = {
  className?: string;
  imgSrc?: string | null;
  description?: string;
  title?: string;
  ctaText?: string;
  buttonColor?: string;
  popupColor?: string;
  withImage?: boolean;
  isMobile?: boolean;
};

export const LeadPopupPreview = ({
  className,
  withImage,
  imgSrc,
  description = '',
  title = '',
  ctaText = '',
  popupColor,
  buttonColor,
  isMobile,
}: Props) => {
  const image = imgSrc || previewMockImg;

  const buttonStyles = buttonColor
    ? {
        backgroundColor: buttonColor,
        color: getComplementaryColor(buttonColor),
      }
    : {};

  const textStyles = popupColor
    ? {
        color: getComplementaryColor(popupColor),
      }
    : {};

  const content = (
    <div
      className={classNames(className, 'lead-popup-preview')}
      style={{
        backgroundColor: popupColor,
      }}
    >
      {withImage && (
        <div className="lead-popup-preview__image">
          <img src={image} alt="Popup preview" />
        </div>
      )}

      <span className="lead-popup-preview__title" style={textStyles}>
        {title}
      </span>

      <span className="lead-popup-preview__description" style={textStyles}>
        {description}
      </span>

      <div className="lead-popup-preview__input-field">
        <span>Enter your phone number</span>
      </div>

      <div className="lead-popup-preview__input-field">
        <span>Your First Name</span>
      </div>

      <div className="lead-popup-preview__input-field">
        <span>Your Last Name</span>
      </div>

      {ctaText && (
        <div className="lead-popup-preview__cta-button" style={buttonStyles}>
          {ctaText}
        </div>
      )}
    </div>
  );

  if (isMobile) return <PreviewIphone>{content}</PreviewIphone>;

  return content;
};
